// extracted by mini-css-extract-plugin
export default {"header":"Tutorials_header__xwh6Y","main":"Tutorials_main__lo1Ud","player":"Tutorials_player__w45ym","videos":"Tutorials_videos__o46+W"};